// extracted by mini-css-extract-plugin
module.exports = {"input":"Comperia_input__PlWIg","cinput":"Comperia_cinput__yvjO8","btn-wrap":"Comperia_btn-wrap__LzipK","cwrap":"Comperia_cwrap__uEXrz"};